<br/>    
    <p class="text-justify"> O cadastramento de sua máquina é uma das prerrogativas necessárias para o acesso e utilização
        das funcionalidades e serviços do novo Conectividade Social ICP – V2. O cadastramento implementa importante camada de segurança às transações realizadas pelo canal,
        permitindo a identificação inequívoca do equipamento ao qual as operações foram realizadas,
        dentre outras verificações.
    </p>
    <br/>
    <p class="text-justify">
        As informações da máquina serão utilizadas na composição de um código específico que permitirá a
        sua identificação nos acessos futuros, não sendo realizadas a captura ou armazenamento de dados
        particulares dos equipamentos.
    </p>
    <br/>
    <p class="text-justify">
        A partir do cadastramento, a máquina será vinculada à inscrição CNPJ/CEI, e o acesso ao Conectividade
        Social ICP - V2, somente será possível com a utilização do respectivo certificado digital ou Token
        Conectividade.        
    </p>
    <br/>